import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Image from 'next/image';
import styles from '@/styles/RedirectBuffer.module.scss';
import campusLogo from '@/public/images/campus-badge.svg';
import campuswireLogo from '@/public/images/campuswire-logo.svg';
import slideLeft from '@/public/images/redirect-slide-left.jpg';
import slideCenter from '@/public/images/redirect-slide-center.jpg';
import slideRight from '@/public/images/redirect-slide-right.jpg';
function RedirectBuffer(t0) {
  const $ = _c(18);
  const {
    redirectUrl,
    countdown: t1
  } = t0;
  const initialCountdown = t1 === undefined ? 5 : t1;
  const [countdown, setCountdown] = useState(initialCountdown);
  let t2;
  let t3;
  if ($[0] !== countdown || $[1] !== redirectUrl) {
    t2 = () => {
      if (countdown < 1) {
        if (redirectUrl) {
          window.location.replace(redirectUrl);
        }
        return;
      }
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    };
    t3 = [countdown, redirectUrl];
    $[0] = countdown;
    $[1] = redirectUrl;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src={campusLogo} alt="Campus Logo" className={styles.logo} width={56} height={56} priority={true} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles["logo-section"]}>{t4}<div className={styles.connector}><span className={styles["connector-dot"]} /><span className={styles["connector-line"]} /><span className={styles["connector-dot"]} /></div><Image src={campuswireLogo} alt="Campuswire Logo" className={styles.logo} width={56} height={56} priority={true} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== countdown) {
    t6 = <h1 className={styles.heading} aria-live="polite" aria-atomic="true">Redirecting to Campuswire in {countdown}</h1>;
    $[6] = countdown;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className={styles.subheading}>You are being redirected to your Admissions Portal.</p>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className={styles.content}>{t5}<div className={styles["text-section"]}>{t6}{t7}</div></div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={`${styles.slide} ${styles["slide-left"]}`}><Image src={slideLeft} alt="Student" className={styles["slide-image"]} fill={true} sizes="241px" priority={true} /><div className={styles["slide-overlay-left"]} /></div>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image src={slideCenter} alt="Student" className={styles["slide-image"]} fill={true} sizes="284px" priority={true} />;
    t11 = <div className={styles["slide-overlay"]} />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t10 = $[12];
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={`${styles.slide} ${styles["slide-center"]}`}>{t10}{t11}<div className={styles["slide-content"]}><p className={styles["slide-name"]}>CAMRYN KINNEY</p><p className={styles["slide-title"]}>CAMPUS GRAD, 2024</p></div></div>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className={styles["carousel-section"]}><div className={styles["carousel-container"]}><div className={styles["slide-wrapper"]}>{t9}{t12}<div className={`${styles.slide} ${styles["slide-right"]}`}><Image src={slideRight} alt="Student" className={styles["slide-image"]} fill={true} sizes="241px" priority={true} /><div className={styles["slide-overlay-right"]} /></div></div></div></div>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t8) {
    t14 = <div className={styles.container}>{t8}{t13}</div>;
    $[16] = t8;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  return t14;
}
export default RedirectBuffer;